import 'core-js/modules/es.regexp.to-string.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/web.url-search-params.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.string.starts-with.js';
import { __rest } from '../../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { Envs } from '../../../envs.js';

// Check if the test mode is enabled to avoid calling Imaginary
const isTestMode = Envs.NODE_ENV === 'test';
const ImaginaryImageProcessor = _a => {
  var {
      sourceUrl,
      processParameter: {
        outputType,
        quality = 70,
        width,
        height
      },
      sourceName,
      ownerId,
      style
    } = _a,
    props = __rest(_a, ["sourceUrl", "processParameter", "sourceName", "ownerId", "style"]);
  const format = outputType === 'auto' ? 'webp' : outputType;
  // Define the endpoint based on whether resizing is needed
  const endpoint = width || height ? 'resize' : 'convert';
  // Construct the final base URL
  const baseUrl = `${Envs.IMAGINARY_SERVER_URL}/${endpoint}`;
  const processOptionsQueryString = new URLSearchParams(Object.assign(Object.assign(Object.assign(Object.assign({
    url: sourceUrl
  }, width && {
    width: String(width)
  }), height && {
    height: String(height)
  }), quality && {
    quality: String(quality)
  }), {
    type: format
  })).toString();
  const isBase64 = sourceUrl.startsWith('data:image/png;base64,'); // Check if the source is a Base64 string
  const imaginaryUrl = `${baseUrl}?${processOptionsQueryString}`;
  const processWithWidth = width * 2;
  const sourceType = 'url';
  const bffAssetProcessImageUrl = `${Envs.BFF_ASSET_URL}/image/process?source_type=${sourceType}&processParameter_type=${endpoint}&processParameter_width=${processWithWidth}&processParameter_outputType=${outputType}&processParameter_quality=${quality}&source_ownerId=${ownerId}&source_url=${encodeURIComponent(sourceUrl)}&source_name=${sourceName}`;
  const urlToRedirect = ownerId && sourceName ? bffAssetProcessImageUrl : imaginaryUrl;
  // Call imaginary if the source is not a Base64 string and the test mode is not enabled
  const finalUrl = isBase64 || isTestMode ? sourceUrl : urlToRedirect;
  const [imgSrc, setImgSrc] = useState(finalUrl);
  const handleImageError = e => {
    e.currentTarget.onerror = null;
    setImgSrc(sourceUrl);
  };
  // eslint-disable-next-line jsx-a11y/alt-text
  return jsx("img", Object.assign({
    src: imgSrc,
    width: width,
    onError: handleImageError,
    style: style,
    height: height
  }, props));
};

export { ImaginaryImageProcessor };
